/* SLP contact form. Attaches to every [data-slp-contact-form].
   - Blocks the submit when the honeypot field ([data-slp-contact-trap]) has been filled in.
   - Swaps the button label to its sending state and marks it busy while the page posts.
   - Moves focus to the success or error message when the page comes back with one.
   Each form binds once, guarded by data-slp-init. */
(function () {
  'use strict';

  function setup(form) {
    if (form.hasAttribute('data-slp-init')) return;
    form.setAttribute('data-slp-init', '');
    var trap = form.querySelector('[data-slp-contact-trap]');
    var button = form.querySelector('[data-slp-contact-submit]');
    var message = form.querySelector('[data-slp-contact-message]');

    form.addEventListener('submit', function (event) {
      if (trap && trap.value) {
        event.preventDefault();
        return;
      }
      if (button) {
        button.setAttribute('aria-busy', 'true');
        var label = button.querySelector('span');
        var sending = button.getAttribute('data-label-sending');
        if (label && sending) label.textContent = sending;
      }
    });

    if (message) {
      message.focus({ preventScroll: false });
    }
  }

  function init() {
    var forms = document.querySelectorAll('[data-slp-contact-form]');
    for (var i = 0; i < forms.length; i++) setup(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
